// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Change\ApiChange.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { AutomationSystem, AutomationSystemData, AutomationSystemOptions } from 'data/models/AutomationSystem';
import { BerthReservationVersion, BerthReservationVersionData, BerthReservationVersionOptions } from 'data/models/BerthReservationVersion';
import { CoordinationCardVersion, CoordinationCardVersionData, CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { ItineraryPointVersion, ItineraryPointVersionData, ItineraryPointVersionOptions } from 'data/models/ItineraryPointVersion';
import { JobOrderVersion, JobOrderVersionData, JobOrderVersionOptions } from 'data/models/JobOrderVersion';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PortCallVersion, PortCallVersionData, PortCallVersionOptions } from 'data/models/PortCallVersion';
import { RecurringBatchVersion, RecurringBatchVersionData, RecurringBatchVersionOptions } from 'data/models/RecurringBatchVersion';
import { ScheduleDateVersion, ScheduleDateVersionData, ScheduleDateVersionOptions } from 'data/models/ScheduleDateVersion';

// ChangeData is the class that Change serializes to/from
export interface ChangeData {
    Id : number;
	
    Automation : AutomationSystemData | null;
    BerthReservationVersions : BerthReservationVersionData[] | null;
    CoordinationCardVersions : CoordinationCardVersionData[] | null;
    EventsAbout : EventData[] | null;
    EventsCreated : EventData[] | null;
    EventsReferencing : EventData[] | null;
    ItineraryPointVersions : ItineraryPointVersionData[] | null;
    JobOrderVersions : JobOrderVersionData[] | null;
    PortCallVersions : PortCallVersionData[] | null;
    RecurringBatchVersions : RecurringBatchVersionData[] | null;
    ScheduleDateVersions : ScheduleDateVersionData[] | null;
    User : PCUserData | null;
	
    Date : /* ISO8601 */ string;
}

// ChangeOptions is the class which may be passed to the Change constructor to define optional initial data values
export interface ChangeOptions {
    Id : number;
	
    Automation? : AutomationSystemOptions | null;
    BerthReservationVersions? : BerthReservationVersionOptions[] | null;
    CoordinationCardVersions? : CoordinationCardVersionOptions[] | null;
    EventsAbout? : EventOptions[] | null;
    EventsCreated? : EventOptions[] | null;
    EventsReferencing? : EventOptions[] | null;
    ItineraryPointVersions? : ItineraryPointVersionOptions[] | null;
    JobOrderVersions? : JobOrderVersionOptions[] | null;
    PortCallVersions? : PortCallVersionOptions[] | null;
    RecurringBatchVersions? : RecurringBatchVersionOptions[] | null;
    ScheduleDateVersions? : ScheduleDateVersionOptions[] | null;
    User? : PCUserOptions | null;
	
    Date? : /* ISO8601 */ string;
}

export class Change {
    public Id : DataSignal<number>;
	
    public Automation : DataSignal<AutomationSystem | null>;
    public BerthReservationVersions : SDataArray<BerthReservationVersion>;
    public CoordinationCardVersions : SDataArray<CoordinationCardVersion>;
    public EventsAbout : SDataArray<Event>;
    public EventsCreated : SDataArray<Event>;
    public EventsReferencing : SDataArray<Event>;
    public ItineraryPointVersions : SDataArray<ItineraryPointVersion>;
    public JobOrderVersions : SDataArray<JobOrderVersion>;
    public PortCallVersions : SDataArray<PortCallVersion>;
    public RecurringBatchVersions : SDataArray<RecurringBatchVersion>;
    public ScheduleDateVersions : SDataArray<ScheduleDateVersion>;
    public User : DataSignal<PCUser | null>;
	
    public Date : DataSignal<TZDate>;

    constructor();
    constructor(data : ChangeOptions);
    constructor(data: ChangeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Automation = S.value<AutomationSystem | null>(null);
        this.BerthReservationVersions = SArray<BerthReservationVersion>([]);
        this.CoordinationCardVersions = SArray<CoordinationCardVersion>([]);
        this.EventsAbout = SArray<Event>([]);
        this.EventsCreated = SArray<Event>([]);
        this.EventsReferencing = SArray<Event>([]);
        this.ItineraryPointVersions = SArray<ItineraryPointVersion>([]);
        this.JobOrderVersions = SArray<JobOrderVersion>([]);
        this.PortCallVersions = SArray<PortCallVersion>([]);
        this.RecurringBatchVersions = SArray<RecurringBatchVersion>([]);
        this.ScheduleDateVersions = SArray<ScheduleDateVersion>([]);
        this.User = S.value<PCUser | null>(null);
	    
        this.Date = jsonableObservable(S.value<TZDate>(data && data.Date !== undefined ? new TZDate(data.Date) : new TZDate(0), TZDate.eq));
    }

    static key(obj : Change) {
        return obj.Id();
    }
    
    static dataKey(obj : ChangeOptions) {
        return obj.Id;
    }

    static update(obj : Change, data : ChangeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.Date !== undefined) obj.Date(new TZDate(data.Date));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Change.ts